/* tslint:disable:no-empty */
export function noop() { }



// WEBPACK FOOTER //
// ../../src/util/noop.ts